import { IOfferScopePageLang } from '../../../types/lang'

export const offerScopePageLang: IOfferScopePageLang = {
	offer_scope_page: {
		notification_unscoped_offers_count: '{{cnt}} offers_ru',
		notification_unscoped_offers_title: 'are unscoped_ru',
		btn_add_new: 'Add New_ru',
	}
}